import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-box.svg'


const _withScopeId = n => (_pushScopeId("data-v-6e273d02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logo" }
const _hoisted_2 = {
  src: _imports_0,
  alt: "logo box",
  delay: 250
}
const _hoisted_3 = {
  class: "logo__rights",
  delay: 300
}
const _hoisted_4 = { class: "navigation-links" }
const _hoisted_5 = {
  class: "links",
  delay: 450
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "links__title" }, "Product", -1))
const _hoisted_7 = { class: "links__list" }
const _hoisted_8 = { class: "list__item" }
const _hoisted_9 = { class: "list__item" }
const _hoisted_10 = { class: "list__item" }
const _hoisted_11 = { class: "list__item" }
const _hoisted_12 = {
  class: "links",
  delay: 600
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "links__title" }, "Company", -1))
const _hoisted_14 = { class: "links__list" }
const _hoisted_15 = { class: "list__item" }
const _hoisted_16 = { class: "list__item" }
const _hoisted_17 = { class: "list__item" }
const _hoisted_18 = {
  class: "links",
  delay: 750
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "links__title" }, "Community", -1))
const _hoisted_20 = { class: "links__list" }
const _hoisted_21 = { class: "list__item" }
const _hoisted_22 = ["href"]
const _hoisted_23 = { class: "list__item" }
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list__item" }, [
  /*#__PURE__*/_createElementVNode("a", { class: "list__item-link underline-hover" }, " Instagram ")
], -1))
const _hoisted_26 = { class: "list__item" }
const _hoisted_27 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_motion_fade_visible_once = _resolveDirective("motion-fade-visible-once")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
        [_directive_motion_fade_visible_once]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_3, [
        _createTextVNode(" © 2022 Customis3d. All rights reserved ")
      ])), [
        [_directive_motion_fade_visible_once]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("a", {
              class: "list__item-link underline-hover",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.HowItWorks)), ["stop"]))
            }, " How it works ")
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("a", {
              class: "list__item-link underline-hover",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.Products)), ["stop"]))
            }, " Products ")
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("a", {
              class: "list__item-link underline-hover",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.Shopify)), ["stop"]))
            }, " Shopify ")
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("a", {
              class: "list__item-link underline-hover",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.Plans)), ["stop"]))
            }, " Pricing ")
          ])
        ])
      ])), [
        [_directive_motion_fade_visible_once]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("a", {
              class: "list__item-link underline-hover",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.scrollToSection($setup.NavigationSections.ContactUs)), ["stop"]))
            }, " Contact us ")
          ]),
          _createElementVNode("li", _hoisted_16, [
            _createVNode(_component_router_link, {
              to: "/privacy",
              class: "list__item-link underline-hover"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Privacy Policy ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createVNode(_component_router_link, {
              to: "/returns",
              class: "list__item-link underline-hover"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Returns Policy ")
              ]),
              _: 1
            })
          ])
        ])
      ])), [
        [_directive_motion_fade_visible_once]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("ul", _hoisted_20, [
          _createElementVNode("li", _hoisted_21, [
            _createElementVNode("a", {
              href: $setup.Urls.CUSTOMIS3D_TWITTER,
              class: "list__item-link underline-hover",
              target: "_blank"
            }, " Twitter ", 8, _hoisted_22)
          ]),
          _createElementVNode("li", _hoisted_23, [
            _createElementVNode("a", {
              href: $setup.Urls.CUSTOMIS3D_VIDEO_CHANNEL,
              class: "list__item-link underline-hover",
              target: "_blank"
            }, " YouTube ", 8, _hoisted_24)
          ]),
          _hoisted_25,
          _createElementVNode("li", _hoisted_26, [
            _createElementVNode("a", {
              href: $setup.Urls.CUSTOMIS3D_LINKEDIN,
              class: "list__item-link underline-hover",
              target: "_blank"
            }, " LinkedIn ", 8, _hoisted_27)
          ])
        ])
      ])), [
        [_directive_motion_fade_visible_once]
      ])
    ])
  ]))
}